import { useState, useEffect } from 'react';
import Cookie from 'js-cookie';
import qs from 'qs';

import superagent from '@ott/superagent';
import { lang } from '@ott/l10n';
import { Product, BannerCustomData } from '../types';

const useBannerData = (
  adUnitId: string,
  product: Product,
  queryParams: Record<string, string | number>
): BannerCustomData => {
  const [bannerData, setBannerData] = useState<BannerCustomData>({ type: 'banner' });
  const region = lang.toUpperCase();
  const reseller = Cookie.get('referrer') || '';
  let query = qs.stringify({ region, product, reseller });

  Object.keys(queryParams).forEach((queryKey) => {
    query += `&${queryKey}=${queryParams[queryKey]}`;
  });

  useEffect(() => {
    superagent
      .get(`/_mark/banners/adUnit/${adUnitId}?${query}`)
      .then(({ body }: any) => {
        if (body?.result) {
          if (body.result?.creatives?.length) {
            const data: BannerCustomData = body.result.creatives[0].customData;

            switch (data.type) {
              case 'banner':
                setBannerData({ ...bannerData, banner: data.banner });
                break;
              case 'bannerWithPopup':
                setBannerData({ type: data.type, banner: data.banner, popup: data.popup });
                break;
              case 'popup':
                setBannerData({ type: data.type, popup: data.popup });
                break;
              default:
                break;
            }
          }
        }
      })
      .catch((error: unknown) => {
        console.error(error);
      });
  }, []);

  return bannerData;
};

export default useBannerData;
